import { render } from "./PageIchimokuEma4hStrategy.vue?vue&type=template&id=5ea7cbf2"
import script from "./PageIchimokuEma4hStrategy.vue?vue&type=script&lang=js"
export * from "./PageIchimokuEma4hStrategy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__